import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Map } from 'maplibre-gl';
import { MapComponent } from 'src/app/instant-analysis/map/map.component';
import { MapConfig } from 'src/app/instant-analysis/models/map-config';
import { ServiceService } from 'src/app/instant-analysis/services/service.service';
import { MapManagerService } from 'src/app/instant-analysis/services/map-manager/map-manager.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { routerToMainService } from 'src/app/instant-analysis/services/routerToMainService';
import { HistoryService } from '../services/history/history.service';
import { Feature } from '@turf/helpers';
import { Tempo } from 'src/app/instant-analysis/models/tempo';
import { HeatmapType } from 'src/app/instant-analysis/models/heatmap-type';
import { ColorType } from 'src/app/instant-analysis/models/color-type';
import { MathAux } from 'src/app/instant-analysis/services/math-aux/math-aux';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { FeatureCollection, Geometry, MultiPolygon, Point, Polygon } from 'geojson';
import { RainChartComponent } from '../rain-chart/rain-chart.component';
import { ConfigGraficoChuvas } from '../models/config-grafico-chuvas';
import { DiscreteChartComponent } from '../discrete-chart/discrete-chart.component';
import { HistoryHeatmatrixComponent } from '../history-heatmatrix/history-heatmatrix.component';
import { mean,median, min} from 'd3-array';
import { mode } from 'd3-array';
import { TimespanService } from 'src/app/instant-analysis/services/timespan/timespan.service';
import { MatDialog } from '@angular/material/dialog';
import { Status } from '../models/status';
import { EventChartComponent } from '../event-chart/event-chart.component';
import { EventsConfig } from 'src/app/instant-analysis/models/events-config';
import * as turf from '@turf/turf'
import * as d3 from 'd3';
import { MapboxDrawCustom } from 'src/app/instant-analysis/map/mapbox-aux/mapbox-draw-const';
import { PDFAux } from 'src/app/instant-analysis/services/pdf-aux/pdf-aux';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { DashboardToMapService } from 'src/app/dashboard/services/dashboard-to-map-service.service';
import { Analise, Camada, TipoAnalise } from 'src/app/dashboard/models/analise';
import { SocketIoServerService } from 'src/app/instant-analysis/services/socket-io-server/socket-io-server.service';
import { HeuristicService } from '../../routes/services/heuristic/heuristic.service';
import { StartableFromRouter } from 'src/app/dashboard/models/startable-from-router';
import { VoronoiService } from 'src/app/instant-analysis/services/voronoi/voronoi.service';
import { Overlay } from '@angular/cdk/overlay';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { QueryProgressService } from '../services/query-progress/query-progress.service';
import { GrupoChuvaEstacao } from '../models/grupo-chuva-estacao';
import { TimeResolution } from '../models/time-comparator/time-resolution';
import { TimeResolutionInDays } from '../models/time-comparator/time-resolution-in-days';
import { RainDuration } from '../models/rain-duration';
import { Item } from 'vega';
import { LayerParams } from 'src/app/instant-analysis/map/layer-manager';
import { RainCalendarItem } from 'src/app/shared/models/interfaces/rain-calendar-item';
import { MapLayer } from 'src/app/instant-analysis/layers/map-layer';
import { finalize } from 'rxjs/operators';
import { MapConfigService } from 'src/app/shared/services/map-config/map-config.service';
import { ExportMapService } from 'src/app/instant-analysis/services/export-map/export-map.service';

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

/**
 * Página do mapa da análise intervalar. Em vez de o mapa exibir os índices 
 * pluviométricos acumulados, exibe estatísticas de chuva calculadas dentro do
 * intervalo. As estatísticas são duração da chuva nas intensidades fraca,
 * moderada, forte, muito forte, e total, porcentagem de registros de chuva,
 * média, moda e mediana.
 */
@Component({
  selector: 'app-history-map',
  templateUrl: './history-map.component.html',
  styleUrls: ['./history-map.component.css']
})
export class HistoryMapComponent extends MapComponent {

  map: Map;
  mapContainerId = 'map-2';

  rainChartDragDisabled = true;
  charts_menu = false
  discreteChartDragDisabled = true;
  eventChartDragDisabled = true;
  rainChartVisibility = 'disabled';
  discreteChartVisibility = 'disabled';
  eventChartVisibility = 'disabled';
  tempos : Tempo[]= []

  timestampArray = ["total","percent","nfraca","nmoderada","nforte","nmuitoforte","mean","mode","median",];
  timeColumns: {name: string, text: string}[] = [
    { name:'total', text: 'Total de chuva'},
    { name:'percent', text: '% de chuva'},
    { name:'nfraca', text: 'Total de fraca'},
    { name:'nmoderada', text: 'Total de moderada'},
    { name:'nforte', text: 'Total de forte'},
    { name:'nmuitoforte', text: 'Total de muito forte'},
    { name:'mean', text: 'Média'},
    { name:'mode', text: 'Moda'},
    { name:'median', text: 'Mediana'}
  ]  

  /** */
  typeofcalculation = 1;

  /** */
  aggregateRainInterval: TimeResolution = TimeResolution.ONE_HOUR;

  @ViewChild(SidebarComponent) sidebar: SidebarComponent ;
  @ViewChild(RainChartComponent) rainChart: RainChartComponent;
  @ViewChild(DiscreteChartComponent) discreteChart: DiscreteChartComponent;
  @ViewChild(EventChartComponent) eventChart: EventChartComponent;
  @ViewChild(HistoryHeatmatrixComponent) historyHeatmatrix: HistoryHeatmatrixComponent;

  /** Progresso (0 a 100) da consulta de chuva no intervalo de tempo para construir a heat matrix  */
  intervalQueryProgressPercentage: number = 0;

  /** */
  RainIntervalQueryProgress$: Subscription;

  /** */
  RainInterval$: Subscription;

  /** */
  Agregados$: Observable<GrupoChuvaEstacao[]>;

  mapConfig: MapConfig = this.mapConfigService.intervalMapConfig;

  includePointsButtonInMapDraw = false;

  constructor(
    service: ServiceService,
    mapManager: MapManagerService,
    snackBar: MatSnackBar,
    routerMessager: routerToMainService,
    voronoiService: VoronoiService,
    overlay: Overlay,
    mapConfigService: MapConfigService,
    exportMapService: ExportMapService,
    timespanService:TimespanService,
    private historyService: HistoryService,
    public dialog: MatDialog,
    protected routerReciever: DashboardToMapService,
    protected socketIo: SocketIoServerService,
    protected heuristicService: HeuristicService,
    private queryProgressService: QueryProgressService,) {

    super(
      service, 
      mapManager, 
      snackBar, 
      routerMessager, 
      dialog, 
      routerReciever, 
      socketIo, 
      heuristicService, 
      voronoiService, 
      overlay, 
      mapConfigService, 
      exportMapService, 
      null, 
      null,
      timespanService);
  }

  protected observeRouteChildrenEmitter() {

  }

  ngAfterViewInit(){

    const updateArea = (e:any) => {

      // Quando se arrasta o polígono por estações, o array e.features vem vazio,
      // e isso causa erros.
      if (e.features.length == 0) {
        return;
      }

      let name = "";
      if (e.type == 'draw.create'){  
          this.openDialog().afterClosed().subscribe((result: { nomeRegiao: string; })=> {
            name = result.nomeRegiao;
            let newRegion = this.switchTypeOfPointFromPolygon(e.features[0],name)
            this.historyHeatmatrix.addRegionToTable(newRegion)
            e.features[0].properties.nome_estacao_original = name
            let index = this.historyHeatmatrix.displayState - 1
            MapboxDrawCustom.recolorFeature(this.map_draw,newRegion[index],this.mapConfig.geoData.selectedColumn)
            this.mapConfig.geoData.polygons.push(e.features[0]);
          });  
      } else if (e.type == 'draw.update' || e.type == 'draw.delete'){
        let localindex = this.mapConfig.geoData.polygons.findIndex(val =>{
          return val.id == e.features[0].id
        })      
        if (e.type == 'draw.update'){
          let newRegion = this.switchTypeOfPointFromPolygon(e.features[0],this.mapConfig.geoData.polygons[localindex].properties.nome_estacao_original)
          this.historyHeatmatrix.updateRegionFromTable(newRegion)
          e.features[0].properties.nome_estacao_original = this.mapConfig.geoData.polygons[localindex].properties.nome_estacao_original
          let index = this.historyHeatmatrix.displayState - 1
          MapboxDrawCustom.recolorFeature(this.map_draw,newRegion[index],this.mapConfig.geoData.selectedColumn)

          this.mapConfig.geoData.polygons[localindex] = e.features[0];
        }else{
          this.historyHeatmatrix.removeRegionFromTable([e.features[0]])
          this.map_draw.delete(e.features[0].id)
          this.mapConfig.geoData.polygons = this.mapConfig.geoData.polygons.filter(val => val.id != e.features[0].id);
        }
      }
    }

    this.map.on('draw.create', updateArea);
    this.map.on('draw.delete', updateArea);
    this.map.on('draw.update', updateArea);
  }

  /**
   * Alterna a exibição da barra lateral.
   */
  toggleSidebar() {
    this.showSidebar = ! this.showSidebar;
  }

  /**
   * Obtém uma instância da barra lateral.
   * @returns referência da barra lateral.
   */
  getToolbar() {
    return this.sidebar;
  }

  /**
   * Chamada quando o botão de tempo real da barra de menu é clicado.
   * Define os campos de data e hora da toolbar para o tempo atual, e atualiza o mapa.
   */
  searchNow(){
    let currentDate = new Date();
    let startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);

    const { formatTime, formatDate } = this.timespanService;

    let startHourStr = formatTime(startDate);
    let startDateStr = formatDate(startDate);

    let finalHourStr = formatTime(currentDate);
    let finalDateStr = formatDate(currentDate);

    this.mapConfig.time.startDate = startDateStr;
    this.mapConfig.time.startTime = startHourStr;

    this.mapConfig.time.endDate = finalDateStr;
    this.mapConfig.time.endTime = finalHourStr;

    this.getToolbar().updateMap(true);
  }

  /**
   * 
   * @param mapConfig 
   */
  /*
  onNewTimeSearch() {

    let { startDatetime, endDatetime } = this.mapConfig.time;
    let { completeness, dataSource } = this.mapConfig.dataFilter;

    // evitar sobreposição de listeners
    if ( this.RainIntervalQueryProgress$ != null ) {
      this.RainIntervalQueryProgress$.unsubscribe();
    }

    if ( this.RainInterval$ != null ) {
      this.RainInterval$.unsubscribe();
    }

    this.intervalQueryProgressPercentage = 0;
    this.queryProgressService.startRainIntervalQuery(startDatetime, endDatetime, completeness, dataSource);
    
    this.RainIntervalQueryProgress$ = this.queryProgressService
      .getRainIntervalProgress()
      .subscribe((progress) => {
        this.sidebar.intervalQueryProgressPercentage = progress;
      });

    this.RainInterval$ = this.queryProgressService.getRainIntervalResults()
      .subscribe(({ success, message, data }) => {

      if (success == false) {

        this.switchTable(false);
        this.toggleRainChart(false);
        this.toggleDiscreteChart(false);

        this.snackBar.open(message, '', {duration: 6000});
      }

      let {
        timeRows, stationsStats, neighborhoodsStats, cityRainDurationInSeconds
      } = data;

      // TODO: parar de usar registros de tempo
      this.setTimeInterval(timeRows);

      this.mapConfig.geoData.stations = stationsStats;
      this.mapConfig.geoData.filteredStations = this.filterRainData();
      this.mapConfig.time.tempo = timeRows;
      this.calcNeighborhoods = neighborhoodsStats;

      this.onRainValuesInterval(
        neighborhoodsStats,
        cityRainDurationInSeconds,
      );

      this.getEventValues(timeRows[0].id_tempo, timeRows[1].id_tempo);

      this.voronoiService
        .getEventsCountPerVoronoiCell(
          startDatetime, 
          endDatetime, 
        )
        .subscribe(result => {
          this.onVoronoiEventsCount(result);
        });

      // Depois de ter a resposta, não é necessário ficar escutando mais
      this.RainInterval$.unsubscribe();
      this.RainIntervalQueryProgress$.unsubscribe();
    })

    this.fetchRainAggregatesForChart();
  }
  */

  /**
   * 
   * @param mapConfig 
   */
  onNewTimeSearch() {

    let { startDatetime, endDatetime } = this.mapConfig.time;
    let { completeness, dataSource } = this.mapConfig.dataFilter;
    
    let requests = [
      this.historyService.getRainDataInInterval(startDatetime, endDatetime),
      this.historyService.getNeighborhoodRainDataInInterval(startDatetime, endDatetime),
      this.historyService.getCityRainDurationInInterval(startDatetime, endDatetime),
    ];

    forkJoin(requests).subscribe((result) => {

      const rainStats = result[0] as { stationsStats: FeatureCollection<Point>, timeRows: Tempo[] };
      const neighborhoodStats = result[1] as FeatureCollection<Point>;
      const cityRainDurationInSeconds = result[2] as RainDuration;
      
      this.mapConfig.geoData.stations = rainStats.stationsStats;
      this.mapConfig.geoData.filteredStations = this.filterRainData();
      this.mapConfig.time.tempo = rainStats.timeRows;

      this.calcNeighborhoods = neighborhoodStats.features;

      this.fetchRainAggregatesForChart();
      this.initDiscreteChart(cityRainDurationInSeconds);

      const [t0, tf] = rainStats.timeRows;
      this.getEventValues(t0.id_tempo, tf.id_tempo)

      this.updateHeatMap();
    });
  }

  /**
   * Filtra os registros de chuva.
   * @returns registros de chuva filtrados.
   */
  protected filterRainData() {

    let { stations } = this.mapConfig.geoData;
    let { dataSource, completeness } = this.mapConfig.dataFilter;
    
    // filtros
    
    // fonte dos dados
    const dataSourceFilter = (f: Feature) => dataSource.includes(f.properties.fonte);
    
    // porcentagem de completude
    const completenessFilter = (f: Feature) => {
        return f.properties['compporcem'] >= completeness;
    };

    let filteredGeojson: FeatureCollection<Point> = {
      'type': 'FeatureCollection',
      'features': stations.features
        .filter(dataSourceFilter)
        .filter(completenessFilter)
    }

    return filteredGeojson;
  }


  /**
   * Busca os dados dos agregados de chuvas para a construção do gráfico de linhas
   */
  private fetchRainAggregatesForChart() {

    this.onRainChartLoading();

    let { startDatetime, endDatetime } = this.mapConfig.time;
    this.calcAggregateRainInterval();
    this.Agregados$ = this.historyService.getRainDataAggregatesInInterval(
      startDatetime, endDatetime, this.aggregateRainInterval
    );
    this.Agregados$.subscribe((val: GrupoChuvaEstacao[]) => {

      this.onRainAggregates({
        estacoesTemposChuvas: val,
        resolucaoTempo: this.aggregateRainInterval,
        dataInicial: startDatetime,
        dataFinal: endDatetime,
      });
    });
  }

  /**
   * Calcula a diferença em dias entre as datas inicial e final, e define a configuração do
   * tipo de intervalo.
   */
  calcAggregateRainInterval() {

    let { startDatetime, endDatetime } = this.mapConfig.time;

    let diff = (new Date(endDatetime).valueOf()) - (new Date(startDatetime).valueOf());
    let [days, hours, minutes] = this.timespanService.calcTimespan(diff);

    this.aggregateRainInterval = this.calcTimeResolution(days);
  }

  /**
   * Obtém os dados do tipo de intervalo, de acordo com o número de dias entre as datas
   * inicial e final 
   * 
   * @param days número de dias entre as datas inicial e final
   * @returns objeto de configuração do intervalo de tempo, com a palavra chave do intervalo no
   *    banco de dados, e o nome da coluna que deve ser usada para acessar o agregado de chuva.
   */
  calcTimeResolution(days: number): TimeResolution {
  
    if (days > TimeResolutionInDays.SIX_MONTHS) {
      return TimeResolution.ONE_MONTH;
    }
    if (days > TimeResolutionInDays.TWO_WEEKS) {
      return TimeResolution.ONE_DAY;
    }
      return TimeResolution.ONE_HOUR;
  }

  /**
   * Trata o recebimento de dados de chuvas dentro do intervalo de tempo solicitado.
   * Faz chamada que inicializa o gráfico de duração das chuvas por estação,
   * calcula as estatísticas das chuvas, como durações, valores médios, moda e mediana;
   * atualiza as camadas do mapa usando os dados de chuvas recebidos. 
   * @param values 
   */
  onRainValuesInterval(neighborhoodsStats: Feature<Point>[], cityRainDurationInSeconds: RainDuration) {
    let stationList : FeatureCollection<Point> = this.mapConfig.geoData.filteredStations;
    this.discreteChart.setRainFeatures(MathAux.deepCopy(stationList.features));
    this.discreteChart.setCityRainDurationInSeconds(cityRainDurationInSeconds);
    this.discreteChart.setTempos(this.mapConfig.time.tempo);
    this.discreteChart.updateChart();

    // this.calcNeighborhoods = neighborhoodsStats;    
    this.updateHeatMap();
  }

  /**
   * Inicializa o gráfico de barras da duração das intensidades da chuva.
   * @param cityRainDurationInSeconds duração das intensidades das chuvas na cidade inteira, em segundos.
   */
  initDiscreteChart(cityRainDurationInSeconds: RainDuration) {

    let stationList : FeatureCollection<Point> = this.mapConfig.geoData.filteredStations;
    this.discreteChart.setRainFeatures(MathAux.deepCopy(stationList.features));
    this.discreteChart.setCityRainDurationInSeconds(cityRainDurationInSeconds);
    this.discreteChart.setTempos(this.mapConfig.time.tempo);
    this.discreteChart.updateChart();
  }

  /**
   * Trata o recebimento dos dados das ocorrências (MapComponent.getEventValues)
   * @param eventData feature collection das ocorrências
   */
  onEventDataReceived(eventData: FeatureCollection<Point>): void {
    super.onEventDataReceived(eventData);

    const { startDatetime, endDatetime } = this.mapConfig.time;

    // exibir o gráfico de contagem das ocorrências
    const eventsConfig: EventsConfig = {
      events: eventData,
      startDate: startDatetime,
      endDate: endDatetime,
    };
    this.eventChart.initialize(eventsConfig);
    this.eventChart.updateChart();

    if (eventData == null || eventData.features.length == 0) {
      this.toggleEventChart(false);
    }
  }

  /**
   * Trata o recebimento dos dados do gráfico de linhas da chuva.
   * @param values dados a serem exibidos no gráfico.
   */
  onRainAggregates(values: ConfigGraficoChuvas) {
    this.updateRainChart(values);
  }

  /**
   * Atualiza o gráfico de linhas da chuva.
   * @param config dados para exibir no gráfico.
   */
  updateRainChart(config: ConfigGraficoChuvas) {

    this.rainChart.initialize(config);
    this.rainChart.updateChart();
  }

  /**
   * Alterna entre exibir / esconder o gráfico de linhas das chuvas.
   * @param toggle indica se vai exibir ou esconder o gráfico. Se for null, inverte o estado da exibição.
   * @returns 
   */
  toggleRainChart(toggle?: boolean) {
    this.rainChart.closeExpansionPanel();
    if (toggle == null) {
      this.rainChartVisibility = this.rainChartVisibility == 'disabled' ? 'enabled' : 'disabled';
      return;
    }
    this.rainChartVisibility = toggle ? 'enabled' : 'disabled';
  }

  /**
   * Alterna entre exibir / esconder o gráfico discreto das chuvas.
   * @param toggle indica se vai exibir ou esconder o gráfico. Se for null, inverte o estado da exibição.
   * @returns 
   */
  toggleDiscreteChart(toggle?: boolean) {
    this.discreteChart.closeExpansionPanel();
    if (toggle == null) {
      this.discreteChartVisibility = this.discreteChartVisibility == 'disabled' ? 'enabled' : 'disabled';
      return;
    }
    this.discreteChartVisibility = toggle ? 'enabled' : 'disabled';
  }

  /**
   * Alterna entre exibir / esconder o gráfico de eventos (ocorrências).
   * @param toggle indica se vai exibir ou esconder o gráfico. Se for null, inverte o estado da exibição.
   * @returns 
   */
  toggleEventChart(toggle?: boolean) {
    this.eventChart.closeExpansionPanel();
    if (toggle == null) {
      this.eventChartVisibility = this.eventChartVisibility == 'disabled' ? 'enabled' : 'disabled';
      return;
    }
    this.eventChartVisibility = toggle ? 'enabled' : 'disabled';
  }

  /**
   * @override
   * @param heatmapId 
   */
  setToolbarHeatmapType(heatmapId: number) {
    this.sidebar.heatmaptype[heatmapId] = this.mapConfig.layer.list[heatmapId].isActive;
  }


  /**
   * Atualiza o mapa para exibir os heatmaps. Também dispara a atualização da heatmatrix.
   *
   * @param response dados das estações, tipo de heatmap a ser exibido,
   *  tamanho do quadrado da interpolação em Km, percentis de índices pluviométricos, indicador sobre
   *  o tipo do heatmap das vias ser discreto ou não, percentis dos índices pluviométricos discretos.
   */
  updateHeatMap() {
    
    let { filteredStations: rainData, selectedColumn } = this.mapConfig.geoData;
    let { tempo, newSearch } = this.mapConfig.time;
    let { tilesizeInKm, percentile, list } = this.mapConfig.layer;

    // Limpa e inicia a heatmatrix.
    this.historyHeatmatrix.reset(newSearch, tempo, selectedColumn);

    // Não há registros de estações
    if (rainData.features.length == 0) {

      this.onNoRainDataFound();
      return;
    }

    // Ajusta coordenadas e acumulados de chuva das estações.
    rainData = this.mapManager.initialize(
      rainData, selectedColumn, percentile, list[HeatmapType.STATIONS].color, 
      this.timeColumns.map( (val)=>{ return val.name })
    );
    
    // Calcula interpolação das chuvas no bairro.
    // this.calcNeighborhoods = this.calcNeighborhoodData();
    this.mapManager.createAllTimeStampColors(
      {"type": "FeatureCollection", "features": this.calcNeighborhoods}, 
      percentile, 
      list[HeatmapType.NEIGHBORHOOD].color,
      this.timeColumns.map( (val)=>{ return val.name })
    );
    this.calcNeighborhoods.sort((a,b)=>a.properties[selectedColumn] - b.properties[selectedColumn])

    this.historyHeatmatrix.updateTable(rainData.features, this.calcNeighborhoods);

    // Adiciona os polígonos previamente desenhados ao mapa.
    this.mapConfig.geoData.polygons.forEach( val=>{
      this.reloadArea(val);
    });

    // Para estações que têm um acumulado de chuva igual a null, a entrada correspondente
    // em getIndicesPluv será NaN. Por isso, devemos filtrar estações com o selectedColum
    // igual a null. 
    let notNullFeatures = rainData.features.filter(station => station.properties[selectedColumn] != null);
    let notNullRainData: FeatureCollection<Point> = { "type": "FeatureCollection", "features": notNullFeatures } 
    let indicesPluv = this.mapManager.getIndicesPluv(notNullRainData, selectedColumn);

    // calculando os índices pluviométricos para as estações inicialmente, independente de ter layers ativas ou não.
    // middleIndicesPluv pode ser sobrescrito caso haja layers ativas.
    let middleIndicesPluv = MathAux.createMiddleData(indicesPluv, percentile);
    this.mapConfig.geoData.middleIndicesPluv = middleIndicesPluv;

    this.updateRainLayers();

    return;
  }

  /**
   * Remove as linhas de estações e bairros da heatmatrix.
   */
  protected emptyHeatmatrix() {
    this.historyHeatmatrix.updateTable([], []);
  }

  /**
   * 
   */
  getLegendTitle(): string[] {

    let titles: {[key: string]: string[]} = {
      'total': ['Total de chuva'],
      'percent': ['% de chuva'],
      'nfraca': ['Total de fraca'],
      'nmoderada': ['Total de', 'moderada'],
      'nforte': ['Total de forte'],
      'nmuitoforte': ['Total de', 'muito forte'],
      'mean': ['Média'],
      'mode': ['Moda'],
      'median': ['Mediana'],
    };

    let { selectedColumn } = this.mapConfig.geoData;

    return titles[selectedColumn];
  }

  /**
   * 
   * @param tempos O tempo inicial e o tempo final da pesquisa
   */
  setTimeInterval(tempos: Tempo[]){
    this.tempos = tempos
  }

  /**
   * Define o valor do id da estação da linha selecionada na heatmatrix.
   * @param rowId id da estação selecionada
   */
  setHeatMatrixRowId(rowId: number): void {
    this.historyHeatmatrix.selectedId = rowId;
  }

  /**
   * Alterna entre exibir / esconder a heatmatrix.
   * @param toggle indica se vai exibir ou esconder a heatmatrix. Se for null, inverte o estado da exibição.
   */
  switchTable(toggle?: boolean){
    this.heatmatrix_show = toggle == null ? !this.heatmatrix_show : toggle;
    this.historyHeatmatrix.changeView(this.heatmatrix_show);
  }


  /**
   * Transforma todas as propriedades com a tag dada em float
   */
   parseFeaturesToFloat(features: Feature<Point>[], tag : any){
    features.forEach( (val)=>{
      val.properties[tag] = parseFloat(val.properties[tag])
    })
  }

  /**
   * Recolore as regiões poligonais desenhadas no mapa.
   * @param regions regiões poligonais a serem recoloridas.
   */
  recolorAreas(regions:Feature<Point>[][]){
    let index = this.historyHeatmatrix.displayState - 1
    regions.forEach(val=>{
      MapboxDrawCustom.recolorFeature(this.map_draw,val[index],this.mapConfig.geoData.selectedColumn)
    })
    
  }


  /**
   * Função chamada quando faz uma nova busca de dados para o mapa, como a heatmatrix inteira é reconstuida pra se adequar ao novo mapa
   * essa função recalcula o valor dos índices do polígono e joga eles na heatmatrix de volta
   * 
   * @param polygon polígono da area atual
   */
  reloadArea(polygon: Feature<Geometry>){
    let name = polygon.properties.nome_estacao_original ? polygon.properties.nome_estacao_original : polygon.properties.name;
    let pointFeature = this.switchTypeOfPointFromPolygon(polygon,name)
    this.historyHeatmatrix.addRegionToTable(pointFeature)
    let index = this.historyHeatmatrix.displayState - 1
    MapboxDrawCustom.recolorFeature(this.map_draw,pointFeature[index],this.mapConfig.geoData.selectedColumn)
  }

  /**
   * Quando um nome de estação for adicionado / removido na heatmatrix, propaga este nome para que
   * o rain chart também o adicione / remova de sua lista de estações, para que fiquem sincronizados.
   * @param stationName nome da estação a ser adicionada / removida
   */
   onHeatmatrixStationToggled(stationName: string) {

    this.rainChart.toggleSelectedStation(stationName);
  }

  /**
   * Quando um nome de estação for adicionado / removido no rain chart, propaga este nome para que
   * a heatmatrix também o adicione / remova de sua lista de estações, para que fiquem sincronizados.
   * @param stationName nome da estação a ser adicionada / removida
   */
  onRainChartStationToggled(stationName: string) {
    this.historyHeatmatrix.toggleSelectedStation(stationName);
  }

  /**
   * Sinaliza ao gráfico de linhas das chuvas para exibir o status de carregamento LOADING.
   */
  onRainChartLoading() {
    this.rainChart.setStatus(Status.LOADING);
  }

  /**
   * Escole qual a forma de calculo que o polígono vai utilizar:
   * Caso o heatmap esteja ativado, a área vai ser calculada pensando nos valores de cada quadrado da grid
   * Caso ele esteja desativado, a área vai ser calculada pensando nos valores projetodos das ruas
   */
   switchTypeOfPointFromPolygon(polygon: any,name: string) : Feature<Point>[]{

    let { filteredStations } = this.mapConfig.geoData;
    let { percentile, list } = this.mapConfig.layer;

    let stationColor = list[HeatmapType.STATIONS].color;
    let neighborhoodColor = list[HeatmapType.NEIGHBORHOOD].color;
    let colors = [stationColor, neighborhoodColor];

    let isHeatmapLayerActive = list[HeatmapType.HEATMAP].isActive;

    if (isHeatmapLayerActive) {

      let values = [];

      for (let color of colors) {
        let value = this.mapManager.pointFromPolygonUsingGrid(
          polygon,
          name,
          filteredStations,
          color,
          this.timeColumns,
          percentile
        );

        values.push(value);
      }

      return values;      
    }

    let values = [];

    for (let color of colors) {

      let value = this.mapManager.pointFromPolygonUsingHighways(
        polygon,
        name,
        filteredStations,
        color,
        this.timeColumns,
        this.highwaysData.features,
        percentile
      );

      values.push(value);
    }

    return values;
  }

  /**
   * Destaca a linha de um bairro na heatmatrix.
   * @param neighborhoodName nome do bairro a ser destacado.
   */
  protected setMatrixSelectedNeighborhood(neighborhoodName: string) {
    this.historyHeatmatrix.selectedNeighborhood = neighborhoodName;
  }

  /**
   * 
   */
  setRouterIdentity(){
    this.routerMessager.enforceRouterIdentity("2");
  }

  /**
   * Obtém o tipo de formato para uma coluna da heatmatrix. 
   * @param selectedTimestamp nome da coluna da heatmatrix.
   * @returns tipo de formato do valor
   */
  getSpecialArgs(selectedTimestamp:string):string{
    if (selectedTimestamp == "percent")  return "%"
    if (selectedTimestamp == "total" || selectedTimestamp == "nfraca" || selectedTimestamp == "nmoderada"
    || selectedTimestamp == "nforte" || selectedTimestamp == "nmuitoforte")  return "dhm"
    return ""
  }

  /**
   * 
   * @returns Componente Sidebar que implementa StartableFromRouter
   */
  protected getStartableFromRouter(): StartableFromRouter {
    return this.sidebar;
  }


  /**
   * 
   * @returns 
   */
  protected getHeatmapConfig() {
    return this.sidebar.heatmapConfig;
  }

  /**
   * Trata o click em uma data do calendário de chuvas / ocorrências, disparando
   * uma consulta para a data selecionada.
   * @param item item do calendário que tem a data selecionada.
   */
  onRainCalendarItemClicked(item: RainCalendarItem) {

    const { dates, aggregateCol } = item;
    const startDate = dates[0];
    const endDate = new Date(startDate);
    startDate.setMonth(startDate.getMonth() - 1);

    const { formatDate, formatTime, formatDatetime } = this.timespanService;

    const startDatetimeStr = formatDatetime(startDate);
    const endDatetimeStr = formatDatetime(endDate);

    this.mapConfig.time.startDate = formatDate(startDate);
    this.mapConfig.time.startTime = formatTime(startDate);
    this.mapConfig.time.endDate = formatDate(endDate);
    this.mapConfig.time.endTime = formatTime(endDate);

    let toolbar = this.getToolbar();
    toolbar.useSocket();

    const message = `Buscando dados das chuvas entre 
      ${startDatetimeStr} e ${endDatetimeStr}.
      Acompanhe o progresso no menu de intervalo de tempo 
      (canto superior esquerdo da tela).`;
    
    this.snackBar.open(message, '', { duration: 10000, });
  }

    /**
   * nome do campo da porcentagem de completude referente a estação em um instante ou intervalo de tempo
   * @param aggregateCol nome da coluna de acumulado de chuva 
   * @returns nome do campo de completude a ser inserido no pin
   */
    getCompletenessPercentField(aggregateCol:string){
      return `compporcem`;
    }
}
